import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { useNotifyError } from '~/features/hooks/useNotifyError'
import { supabaseApi } from '~/supabase/api'
import { InventoryV2 } from '~/supabase/types'
import { GET_INVENTORY_QUERY_KEY } from '~/features/hooks/useGetInventory'

export type UpdateInventoryPayload = Partial<InventoryV2> & {
  id: number
}

export const useUpdateInventory = () => {
  const { mutate: notifyError } = useNotifyError()
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: ['update-inventory'],
    mutationFn: async (payload: Array<UpdateInventoryPayload>) => {
      const responses = await Promise.all(
        payload.map((data) => supabaseApi.from('inventory_v2').update(data).eq('id', data.id))
      )

      const error = responses.find((r) => !!r.error)

      if (error) {
        toast.error('There was an error updating inventory')
        console.error(error)
        notifyError({
          message: 'There has been an error updating inventory.',
          data: { payload },
          error,
          function: 'updateInventory',
        })
        throw error
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_INVENTORY_QUERY_KEY] })
      toast.success('Inventory updated!')
    },
    onError: (error) => {
      toast.error('Failed to update inventory')
      console.error(error)
    },
  })
}
